import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { default as ApiRequestService, default as apiRequestService } from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import SecureShow from '../component/SecureShow';
import TableRow from '../component/TableRow';
import styles from '../css/styles.css.js';
import subjectStyles from '../css/subjectStyle.css.js';
import { AppSetting } from '../common/function';

let hm_cat = {
  hm_cat_name: '',
  hm_cat_id: ''
};

export default class HelpMenuCat extends Component {
  AppSetting = AppSetting()

  constructor(props) {
    super(props);
    this.state = {
      helpMenuCat: [],
      temp_helpMenuCat: hm_cat,
      temp_id: '',
      visible: false,
      addMode: true,
      loading: true,
      instructor_name: window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`),
      userprofilerole :  parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10),
      instructorHmAccess : 0,
      editingAccess : false
    };

    this.deleteHelpMenuCat = this.deleteHelpMenuCat.bind(this);
    this.addHelpMenuCat = this.addHelpMenuCat.bind(this);
    this.getAllHelpMenuCat = this.getAllHelpMenuCat.bind(this);
    this.changeHelpMenuCatName = this.changeHelpMenuCatName.bind(this);
    this.updateHelpMenuCat = this.updateHelpMenuCat.bind(this);
    //this.getHelpMenuAccess = this.getHelpMenuAccess.bind(this);
    this.isEnterPressed = this.isEnterPressed.bind(this);    
    
    // this.errorMessageHide= this.errorMessageHide.bind(this);
  }

  componentWillMount() {
    console.debug('componentwiollmount',this.state.userprofilerole)
      this.setState({ loading: true });
      if(this.state.userprofilerole === 2){
        this.setState({editingAccess : true})
      }else{
        this.getHelpMenuAccess();
      }
      this.getAllHelpMenuCat();
        
  }  

  componentWillUnmount() {
    this.removeBreadCrumbs();
  }




  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
    

  };
  getHelpMenuAccess = () =>{
    const payload = {
      instructor_name: this.state.instructor_name
    };
    apiRequestService({
      method: 'post',
      url: '/getHmAccess',
      data: payload
    }).then(res => {
      if (res.data.data !== null && res.data.data !== undefined) {
        if( res.data.data.instructor_hm_access === 1){
          this.setState({
            instructorHmAccess : res.data.data.instructor_hm_access,
            editingAccess : true
          })
        }else{
          this.setState({
            instructorHmAccess : res.data.data.instructor_hm_access,
            editingAccess : false
          })
        }
      }
    })
  }
  
  addBreadCrumbs = () => {
    this.props.replaceBreadCrumb([
      { 
        name: 'Help', 
        type: '', 
        onclickPath: 'helpMenuCat' 
      }
    ]);
  };

  componentWillUpdate() {
    this.addBreadCrumbs();
  
  }

  getAllHelpMenuCat(){
    apiRequestService({
      method: 'post',
      url: '/getAllHelpMenuCat'
  }).then(res => {
      if (res.data.data !== null && res.data.data !== undefined) {
         
        this.setState({
          helpMenuCat : res.data.data.hm_cat_names,
          loading: false 
        });                     
      }
  }).catch(err =>{
      console.error('ERROR : ', err);
      NotificationManager.error(err, 'ERROR', 3000);
      this.setState({ loading: false });
      this.hide();
    
  });
  }



  addHelpMenuCat() {
    console.debug('Add  :' + this.state.temp_helpMenuCat.hm_cat_name);
    /*141 Subject, Topic, Cat, Sub Cat Names should not allow empty or empty space*/
    if (
      this.state.temp_helpMenuCat.hm_cat_name === null ||
      this.state.temp_helpMenuCat.hm_cat_name.trim() === ''
    ) {
      alert('Please enter a valid "Category name"');
      return;
    }
    this.setState({ loading: true });
    var tempHelpMenuCat = this.state.temp_helpMenuCat.hm_cat_name.trim();
    const payload = {
      hm_cat_name: tempHelpMenuCat
    };
    ApiRequestService({
      method: 'post',
      url: '/addHelpMenuCat',
      data: payload
    }).then(res => {
      if (res.data.message !== null && res.data.message !== '') {
        console.error('ERROR : ', res.data.message);
        // Bug id #143 fixed
        this.setState({ loading: false });
        this.hide();
        NotificationManager.error(res.data.message, 'ERROR', 3000);
        return;
      }

      if (res.data.data != null) {
        console.debug('response : ', res);
        let tempHelpMenuCat ;
        if(this.state.helpMenuCat === null ||this.state.helpMenuCat === undefined){
          tempHelpMenuCat=[];
        }else{
          tempHelpMenuCat = this.state.helpMenuCat;
        }
        tempHelpMenuCat.push({
          hm_cat_name: res.data.data.hm_cat_name,
          hm_cat_id: res.data.data.hm_cat_id
        });
        this.setState({
          helpMenuCat: tempHelpMenuCat
        });
      }
      this.setState({
        loading: false
      });
      this.hide();
    });
  }

  editHelpMenuCat(id) {
    this.setState({
      temp_helpMenuCat: this.state.helpMenuCat[id],
      temp_id: id,
      addMode: false
    });
    this.show(false);
  }

  updateHelpMenuCat() {
    this.setState({ loading: true });
    console.debug('Editing  :' + this.state.temp_helpMenuCat.hm_cat_id);

    const payload = this.state.temp_helpMenuCat;

    ApiRequestService({
      method: 'post',
      url: '/updateHelpMenuCat',
      data: payload
    }).then(res => {
      if(res.data.message !== null && res.data.message !== ""){
        if(res.data.message.toLowerCase().indexOf("duplicate")>=0){
            NotificationManager.error("Duplicate entry.This Category Already Exists", 'Error Message', 5000);
            this.setState({loading: false
            });
        }else{
            NotificationManager.error(res.data.message, 'Error Message', 5000);
            this.setState({loading: false
            });
        }
    } else {
        NotificationManager.success('Subject Added', 'Success');
    
        console.debug(res);
        console.debug('Update State: ', this.state.helpMenuCat);
        this.setState({
          helpMenuCat: this.state.helpMenuCat,
          temp_helpMenuCat: hm_cat,
          loading: false
        });
        
    }
    });
    this.hide();
    this.getAllHelpMenuCat();
  }
  deleteHelpMenuCat(id) {
    this.setState({ loading: true });
    console.debug(
      'Deleting hm_cat i:' + id + ' id: ' + this.state.helpMenuCat[id].hm_cat_id
    );
    const payload = {
      hm_cat_id: this.state.helpMenuCat[id].hm_cat_id
    };
    ApiRequestService({
      method: 'post',
      url: '/deleteHelpMenuCat',
      data: payload
    })
      .then(res => {
        console.debug(res);
        //window.localtion.reload();
        this.state.helpMenuCat.splice(id, 1);
        console.debug('Spliced Array', this.state.helpMenuCat);
        this.setState({
          helpMenuCat: this.state.helpMenuCat,
          loading: false
        });
      })
      .catch(error => {
        //bug-tracker#162

        console.error('Error When Deleting ', error);
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to delete hm_cat',
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }
  changeHelpMenuCatName(e) {
    console.debug("changeHelpMenuCatName ",e)
    let curHelpMenuCatName = this.state.temp_helpMenuCat;
    curHelpMenuCatName.hm_cat_name = e;
    this.setState({
      temp_helpMenuCat: curHelpMenuCatName
    });
  }

  show = isAddDialogEnable => {
    //

    if (isAddDialogEnable) {
      this.setState({
        temp_helpMenuCat: {
          hm_cat_name: '',
          hm_cat_id: ''
        }
      });
    }
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({
      visible: false,
      addMode: true
    });
  };
  
  delete = id => {
    console.debug('deleteHelpMenuCat(id)',id);
    confirmAlert({
      title: 'Are you sure want to delete this hm_cat?',
      message: 'Press Confirm to submit',
      confirmLabel: 'Cancel',
      cancelLabel: 'Confirm',

      onCancel: () => this.deleteHelpMenuCat(id)
      //   onCancel: () => ,
    });
  };

  isEnterPressed(event){
    var code = event.keyCode || event.which;
    if(code === 13) { //13 is the enter keycode
      if (this.state.addMode) {
        this.addHelpMenuCat()
      } else{
        this.updateHelpMenuCat();
      }
    }
  }

  render() {
    let button = null;
    if (this.state.addMode) {
      button = (
        <Button style={styles.addButton} onClick={this.addHelpMenuCat}>
          Add 
        </Button>
      );
    } else {
      button = (
        <Button style={styles.addButton} onClick={this.updateHelpMenuCat}>
          Update 
        </Button>
      );
    }
    var cancelButton = (
      <Button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </Button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);
    var tableRows = (this.state.helpMenuCat != null
      ? this.state.helpMenuCat.map((hm_cat, i) => (
        
        
          <TableRow
            key={hm_cat.hm_cat_id}
            data={hm_cat}
            id={hm_cat.hm_cat_id}
            name={hm_cat.hm_cat_name}
            title={'Help Category'}
            type={''}
            url={
              'HelpMenuSubCat?hm_cat_id=' +
              hm_cat.hm_cat_id +
              '&hm_cat_name=' +
              hm_cat.hm_cat_name
            }
            onEditClick={() => this.editHelpMenuCat(i)}
            pushId={'hm_cat'}
            onDeleteClick={() => this.delete(i)}
            instructorSubject={this.state.editingAccess}
          />
        ))
      : '')

    return (

      (this.state.loading)?
         <LoadingSpinner loading={this.state.loading} />
      :
      <SecureShow targetRole={1}>

        <div style={{ width: '90%' }}>
          <div style={styles.subjectTitle}>
            Help Category
            <div style={this.state.editingAccess ? {float: "right"}:{display:"none"}}>
              <Button className="archive-button" primary raised 
                onClick={() => this.show(true)}>
                  Add a New Help Category
              </Button>
            </div>
          </div>
          <div>
            {
              <DialogContainer
                id="simple-action-dialog"
                visible={this.state.visible}
                onHide={this.hide}
                actions={actions}
                //title="New Subject"
                width="500px"
              >
              <p style={{fontSize:"medium"}}><b><label for="hmId">Help Category</label></b></p>
{/*                 <input
                  id="hmId"
                  type="text"
                  name="hm_cat_name"
                  defaultValue={this.state.temp_helpMenuCat.hm_cat_name || ''}
                  onChange={this.changeHelpMenuCatName}
                  style={subjectStyles.dialogText}
                  onKeyPress={this.isEnterPressed.bind(this)}              
                /> */}
                <TextField 
                  id="hmId"
                  name="hm_cat_name"
                  value={this.state.temp_helpMenuCat.hm_cat_name || ''}
                  onChange={this.changeHelpMenuCatName}
                  style={subjectStyles.dialogText}
                  onKeyPress={this.isEnterPressed.bind(this)}              
                />
              </DialogContainer>
            }
          </div>
          <table style={styles.subjectTable}>
            <thead style={styles.thead}>
              <tr>
                <th>ID</th>
                <th>Category</th>
                {this.state.editingAccess ? (<th>Actions</th>):("")}
              </tr>
            </thead>

            <tbody>
              {tableRows}
            </tbody>
          </table>
        </div>
        
      </SecureShow>
    );
  }
}
